<div nz-row nzType="flex">
    <div nz-col nzSpan="6">
        <div class="formname">{{formTitle}}</div>
    </div>

    <div nz-col nzSpan="18" style="display: flex; justify-content: flex-end;">
        <form nz-form [nzLayout]="'inline'">
            <nz-form-item>
                <button nz-button [nzType]="filterButtonType" (click)="flterBoxVisibleInvisible()"><i nz-icon
                        nzType="filter"></i></button>
            </nz-form-item>

            <nz-form-item>
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input type="text" name="search" nz-input placeholder="Search Records" [(ngModel)]="searchText"
                        (keydown.enter)="onEnterKeyDown()" />
                </nz-input-group>

                <ng-template #suffixIconButton>
                    <button nz-button id="button1" nzType="primary" (click)="getAllTaskSubtask()" nzSearch><i nz-icon
                            nzType="search"></i></button>
                </ng-template>
            </nz-form-item>

            <!-- <nz-form-item>
                <button nz-button nzType="primary" (click)="add()"><i nz-icon nzType="plus"></i>New Task/
                    Subtask</button>
            </nz-form-item> -->
        </form>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">
        <div class="filter-box" *ngIf="displayFilterBox">
            <form nz-form>
                <div nz-row nzGutter="16">
                    <div nz-col nzSpan="8">
                        <nz-form-label nzNoColon>Project</nz-form-label>

                        <nz-input-group>
                            <nz-select name="ProjectName"   style="width: 100%;" nzShowSearch
                                style="width: 100%" [(ngModel)]="projectID" (ngModelChange)="getModules($event)">
                                <nz-option *ngFor="let category of projectList" [nzValue]="category.ID"
                                    [nzLabel]="category.NAME"></nz-option>
                            </nz-select>
                        </nz-input-group>
                    </div>
                    <div nz-col nzSpan="8">
                        <nz-form-label nzNoColon>Module</nz-form-label>

                        <nz-input-group>
                            <nz-select name="ModuleName"   style="width: 100%;" nzShowSearch
                                style="width: 100%" [(ngModel)]="moduleID">
                                <nz-option *ngFor="let category of moduleList" [nzValue]="category.ID"
                                    [nzLabel]="category.NAME"></nz-option>
                            </nz-select>
                        </nz-input-group>
                    </div>
                    <div nz-col nzSpan="8">
                        <nz-form-label>Actions</nz-form-label><br />

                        <nz-button-group nzSize="default">
                            <button style="margin-right: 10px;" nz-button nzType="primary"
                                (click)="applyFilter()" nzJustify="end">
                                <i nz-icon nzType="filter"></i>Apply Filter
                            </button>

                            <button nz-button nzType="primary" (click)="clearFilter()">
                                <i nz-icon nzType="filter"></i>Clear Filter
                            </button>
                        </nz-button-group>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">
        <nz-table class="my-scroll no-wrap1" nzBordered #table nzShowSizeChanger [nzFrontPagination]="false"
            [nzData]="taskSubtaskData" [nzLoading]="loadingRecords" [nzTotal]="totalRecords" [(nzPageIndex)]="pageIndex"
            [(nzPageSize)]="pageSize" (nzQueryParams)="sort($event)">

            <thead>
                <tr>
                    <!-- <th style="text-align: center;">View</th> -->
                    <th style="text-align: center;">Edit</th>
                    <!-- <th style="text-align: center;">Map</th> -->
                    <!-- <th style="text-align: center;">Attachments</th>
                    <th style="text-align: center;">Worklog</th> -->
                    <!-- <th style="text-align: center;">Task Transfer</th> -->
                    <th *ngFor="let column of columns" nzColumnKey="{{column[0]}}" [nzSortFn]="true">{{column[1]}}</th>
                    <th nzColumnKey="START_DATE" [nzSortFn]="true">Start Date</th>
                    <th nzColumnKey="END_DATE" [nzSortFn]="true">End Date</th>
                    <th style="text-align: center;" nzColumnKey="IS_ACTIVE" [nzSortFn]="true">Active</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let data of table.data">
                    <!-- <td style="text-align: center;"><a (click)="commentTaskSubtask(data)"><i nz-icon nzType="eye"
                                nzTheme="outline"></i></a></td> -->
                    <td style="text-align: center;"><a (click)="edit(data)"><i nz-icon nzType="edit"
                                nzTheme="outline"></i></a></td>
                    <!-- <td style="text-align: center;"><a (click)="mapTaskSubtask(data)"><i nz-icon nzType="form"
                                nzTheme="outline"></i></a></td> -->
                    <!-- <td style="text-align: center;"><a (click)="attachmentTaskSubtask(data)"><i nz-icon nzType="paper-clip" nzTheme="outline"></i></a></td>
                    <td style="text-align: center;"><a (click)="worklogTaskSubtask(data)"><i nz-icon nzType="file-add" nzTheme="twotone"></i></a></td> -->
                    <!-- <td style="text-align: center;"><a (click)="taskTransferHistoryTaskSubtask(data)"><i nz-icon
                                nzType="history" nzTheme="outline"></i></a></td> -->
                    <td *ngFor="let column of columns">{{data[column[0]]}}</td>
                    <td>{{data.START_DATE | date: 'dd MMM, yyyy'}}</td>
                    <td>{{data.END_DATE | date: 'dd MMM, yyyy'}}</td>
                    <td style="text-align: center;">
                        <i nz-icon *ngIf="data.IS_ACTIVE" [nzType]="'check-circle'" [nzTheme]="'twotone'"
                            [nzTwotoneColor]="'#52c41a'"></i>
                        <i nz-icon *ngIf="!data.IS_ACTIVE" [nzType]="'close-circle'" [nzTheme]="'twotone'"
                            [nzTwotoneColor]="'#f50'"></i>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</div>
<div >
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="700" [nzVisible]="drawerVisible"
        [nzTitle]="drawerTitle" (nzOnClose)="drawerClose()" (nzKeyboard)="true">
        <app-task-drawer [drawerClose]="callBackDrawerClose" [data]="taskSubtaskDrawerData"></app-task-drawer>
    </nz-drawer>
</div>
<div >
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="800" [nzVisible]="worklogDrawerVisible"
        [nzTitle]="worklogDrawerTitle" (nzOnClose)="worklogDrawerClose()" (nzKeyboard)="true">
        <app-worklog [dataType]="type" [data]="taskSubtaskDrawerData"></app-worklog>
    </nz-drawer>
</div>
<div >
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="800"
        [nzVisible]="attachmentDrawerVisible" [nzTitle]="attachmentDrawerTitle" (nzOnClose)="attachmentDrawerClose()"
        (nzKeyboard)="true">
        <app-attachment-master [dataType]="type" [data]="taskSubtaskDrawerData"></app-attachment-master>
    </nz-drawer>
</div>
<div >
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="800" [nzVisible]="mappingDrawerVisible"
        [nzTitle]="mappingDrawerTitle" (nzOnClose)="mappingDrawerClose()" (nzKeyboard)="true">
        <app-task-subtask-mapping [drawerClose]="callBackMappingDrawerClose" [data]="taskSubtaskDrawerData"
            [mappingData]="taskMappingDrawerData"></app-task-subtask-mapping>
    </nz-drawer>
</div>
<div >
    <nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
        [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="700" [nzVisible]="commentDrawerVisible"
        [nzTitle]="commentDrawerTitle" (nzOnClose)="commentDrawerClose()" (nzKeyboard)="true">
        <app-comment [data]="taskSubtaskDrawerData" [type]="typeForComment" [typeID]="typeIDForComment" [roadmaptrue]="roadmaptrue"></app-comment>
    </nz-drawer>
</div>